import React, { useCallback } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { IconActivity } from 'design-system/icons';
import { Spacer, hitSlop, rem } from 'design-system';
import IconDonotChart from 'design-system/icons/IconDonotChart';
import { IconSettings } from 'design-system/icons/IconSettings';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { TAB_SCREEN_HEADER_HEIGHT } from 'navigators/styles';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectIsInvestWalkthroughActive } from 'reducers/selectors/walkthrough';
import { isWeb } from '../../../constants';
const PortfolioScreenHeader = ({ isAlpacaAccount, isInTab }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const isInInvestWalkthrough = useAppSelector(selectIsInvestWalkthroughActive);
    const { navigateDeprecated } = useMainStackNavigation();
    const onGoToActivity = useCallback(() => {
        if (isAlpacaAccount) {
            navigateDeprecated('InvestActivity');
            return;
        }
        navigateDeprecated('InvestNewActivityScreen');
    }, [isAlpacaAccount]);
    const onGoToInsights = useCallback(() => {
        navigateDeprecated('InvestInsights');
    }, []);
    const goToSettings = useCallback(() => {
        navigateDeprecated('InvestSettings');
    }, []);
    return (<View style={[styles.headerContainer, isInTab && { height: TAB_SCREEN_HEADER_HEIGHT }]}>
      {isAlpacaAccount ? (<>
          <TouchableOpacity disabled={isInInvestWalkthrough} onPress={onGoToInsights} hitSlop={hitSlop}>
            <IconDonotChart color={colors.text.primary}/>
          </TouchableOpacity>
          <Spacer.W16 />
        </>) : null}
      <TouchableOpacity disabled={isInInvestWalkthrough} onPress={onGoToActivity} hitSlop={hitSlop}>
        <IconActivity color={colors.text.primary}/>
      </TouchableOpacity>
      <Spacer.W16 />
      <TouchableOpacity disabled={isInInvestWalkthrough} onPress={goToSettings} hitSlop={hitSlop}>
        <IconSettings color={colors.text.primary}/>
      </TouchableOpacity>
      {/* The native header adds its own right margin; the web one doesn't */}
      {!!(isInTab || isWeb) && <Spacer w={16}/>}
    </View>);
};
export const headerNegativeVerticalAdjustment = rem(10);
const styleSet = createStyleSheets(() => ({
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    blurbContainer: {
        paddingHorizontal: rem(22),
    },
}));
export default React.memo(PortfolioScreenHeader);
